<template>
  <div ds-component="DsFeedback" v-if="isOpen()" :class="['ds-feedback', type]">
    <alert :type="type" @close="closeFeedback" :hideClose="hideClose">
      <div class="ds-feedback__content">
        <div class="ds-feedback__text">
          {{ text }}
        </div>
        <div class="ds-feedback__action-link" v-if="Boolean(linkText)">
          <ds-button
            class="ds-link ds-link--lg"
            color="ghost"
            @click="onClickLink($event)"
          >
            {{ linkText }}
          </ds-button>
        </div>
      </div>
    </alert>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from 'vue';
import Alert from '../Alert/Alert.vue';
import DsButton from '../Button/Button.vue';

export default Vue.extend({
  name: 'Feedback',
  props: {
    type: {
      type: String,
      default: 'warning'
    },
    text: {
      type: String,
      default: '',
      validator: (value) => {
        const isValid = value.length <= 140;
        if (!isValid) {
          throw new Error('text property contains more than 140 character!');
        }
        return isValid;
      }
    },
    linkText: {
      type: String,
      default: '',
      validator: (value) => {
        const isValid = value.length <= 26;
        if (!isValid) {
          throw new Error(
            'link-text property contains more than 26 character!'
          );
        }
        return isValid;
      }
    },
    linkHref: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: '_blank'
    },
    open: {
      type: Boolean,
      default: null
    },
    hideClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconName() {
      return this.type;
    },
    useLocalOpen() {
      return this.open === null;
    }
  },
  components: {
    Alert,
    DsButton
  },
  data() {
    return {
      localIsOpen: true
    };
  },
  methods: {
    closeFeedback() {
      this.localIsOpen = false;
      this.$emit('update:open', false);
      this.$emit('onClickClose');
    },
    onClickLink(event) {
      if (this.linkHref) {
        window.open(this.linkHref, this.target);
      }
      this.$emit('onClickLink', event);
    },
    isOpen() {
      return this.useLocalOpen ? this.localIsOpen : this.open;
    }
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Feedback.scss';
</style>
